import { App, URLOpenListenerEvent } from '@capacitor/app'
import { FirebaseDynamicLinks } from '@pantrist/capacitor-firebase-dynamic-links'
import React from 'react'

import { config } from '@/config'
import { useRouter } from '@/core'

export const AppUrlListener: React.FC = () => {
  const { router } = useRouter()
  // firebaseダイナミックリンクpage.linkを読み込むための記述
  // ダイナミックリンク削除の際にこちらは削除する
  FirebaseDynamicLinks.addListener(
    'deepLinkOpen',
    (event: URLOpenListenerEvent) => {
      const url = new URL(event.url)
      const path = url.pathname
      router.push(path)
    }
  )

  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    // configで指定されたdeeplinkUrlを含まない場合画面遷移しない
    if (
      ![config.deeplinkDev, config.deeplinkStg, config.deeplinkProd].some(
        link => link && event.url.includes(link)
      )
    )
      return
    const url = new URL(event.url)
    const path = url.pathname
    router.push(path)
  })
  return null
}

export default AppUrlListener
